export default function Arrow({ className = '', left = false }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {left ? (
        <>
          <line x1="20" y1="12" x2="5" y2="12" />
          <polyline points="11 6 5 12 11 18" />
        </>
      ) : (
        <>
          <line x1="4" y1="12" x2="19" y2="12" />
          <polyline points="13 6 19 12 13 18" />
        </>
      )}
    </svg>
  );
}
